<template>
    <div>
        <Row>
            <Col span="12">
                <span class="expand-key">phone: </span>
                <span class="expand-value">{{ row.phone }}</span>
            </Col>
            <Col span="12">
                <span class="expand-key">wechat: </span>
                <span class="expand-value">{{ row.wechat }}</span>
            </Col>
        </Row>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object
        }
    };
</script>
<style scoped>

</style>